module.exports = __webpack_public_path__ + "media/images/samples/1280x768/5-280df58637b868fc34b613132194a8c3.jpg";